// navigate.ts
let navigateFn: (path: string) => void;

export const setNavigate = (navFn: (path: string) => void) => {
  navigateFn = navFn;
};

export const navigate = (path: string) => {
  if (navigateFn) navigateFn(path);
};
